import { Dto } from '@core/data/dto/dto';
import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { EmployeeSchema } from './employee.schema';
import { DtoType } from '@core/data/dto/dto-types';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { EmployeeAction } from './employe-action';
import { User } from '../user/user';
import { EmployeeProvider } from './employee-provider';
import { EmployeeProviderData } from './employee-provider-data';
import { EmployeeOnboardStatus } from './employee-onboard-status';
import { EmployeeLinkStatus } from './employee-link-status';
import { ListItem } from '../common/list-item';
import { Entity } from '@core/data/dto/entity';
import { ListSortBy } from '../common/list-sort-by';
import { ListGroupBy } from '../common/list-group-by';
import { Moment } from 'moment';
import { Workplace } from '../shared/workplace/workplace';
import { Paystub } from '../shared/paystub/paystub';
import { EmployeeIssue } from './employee-issue';
import { PaymentMethod } from '../shared/payment-method';
import { EmployeeResidence } from './employee-residence';
import { EmployeeWageType } from './employee-wage-type';
import { EmployeeWage } from './employee-wage';
import { PaySchedule } from '../pay-schedule/pay-schedule';
import { LeavePolicy } from '../leave/leave-policy';

@DtoForceConstructor
export class Employee implements ListItem, Entity {
    public id: string;
    public avatarUrl: string;
    public connection: User;
    public email: string;
    public firstName: string;
    public middleName: string;
    public lastName: string;
    public name: string;
    public linkId: string;
    public linkStatus: EmployeeLinkStatus;
    public ignoreLink: boolean;
    public onboardStatus: EmployeeOnboardStatus;
    public paySchedule: PaySchedule;
    public phone: string;
    public paymentMethodPreference: PaymentMethod;
    public providerId: string;
    public provider: EmployeeProvider;
    public providerData: EmployeeProviderData;
    public providerName: string;
    public providerType: string;
    public warnings: EmployeeIssue[] = [];
    public workplaces: Workplace[] = [];
    public w2ElectronicConsentProvided: boolean;
    public dateOfBirth: Moment;
    public residence: EmployeeResidence;
    public startDate: Moment;
    public terminationDate: Moment;
    public inactiveDate: Moment;
    public actions: EmployeeAction[] = [];
    public ssnLastFour: string;
    public currentWage: {
        id: string;
        wageType: EmployeeWageType;
        wageTypeLabel: string;
        effective: Moment;
        amount: number;
    };
    public nextWage: {
        wageType: EmployeeWageType;
        wageTypeLabel: string;
        effective: Moment;
        amount: number;
    };
    public wages: EmployeeWage[] = [];
    public paystubs: Paystub[] = [];
    public policies: LeavePolicy[] = [];
    public loading: boolean = false;
    public selected: boolean = false;

    @DtoImport(EmployeeSchema)
    static import(dto: Dto): any {
        return new Employee(dto);
    }

    constructor(value?: any) {
        if (value) {

            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: EmployeeSchema,
        },
    ])
    export(type?: DtoType): any {}

/**
     * Validates if this item matches the selected groups.
     * @param groupBy
     * @param selectedGroups
     * @returns {boolean}
     */
    isMatchingGroup(
        groupBy: ListGroupBy,
        selectedGroups: string[]
    ): boolean {
        const isMatched: boolean = false;
        return isMatched;
    }

    /**
     * Validates if this item matches the filter.
     * @param filterBy
     * @param filterValue
     * @returns {boolean}
     */
    isMatchingFilter(filterBy: string, filterValue: any): boolean {
        let isMatching: boolean = true;
        return isMatching;
    }

    /**
     * Returns the relevant group data for this item.
     * @param groupBy
     * @returns {string}
     */
    getGroup(groupBy?: ListGroupBy): string {
        let group: string = '';

        return group;
    }

    /**
     * Custom comparision used by sort.
     * Ref is the value to sort / compare by.
     * @param ref
     */
    valueOf(ref?: ListSortBy): any {
        return this;
    }
}
